import ContainerLeft from './ContainerLeft'

export default ContainerLeft
